import React, { useRef } from "react";
import Input from "~/admin/components/Input";
import Label from "~/admin/components/Label";
import ValidationForm from "~/admin/components/ValidationForm";
import SubmitButton from "~/admin/components/SubmitButton";
import * as Yup from "yup";
import ValidationErrors from "~/admin/services/ValidationErrors";
import LoginApi from "~/admin/apis/login.api";
import Notifications from "~/admin/services/Notifications";
import Authentication from "~/admin/services/Authentication";
import useNavigation from "~/admin/hooks/useNavigation";
import { Navigate } from "react-router-dom";
import useLoader from "~/hooks/useLoader";

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email(ValidationErrors.isEMail)
    .required(ValidationErrors.required),
  password: Yup.string().required(ValidationErrors.required),
});

export default function LoginPage() {
  const { navigate } = useNavigation();
  const form = useRef();
  const loader = useLoader();

  const submit = async (values, formik) => {
    loader.show();
    let response = await LoginApi.login({
      email: values.email,
      password: values.password,
    }).catch((e) => {
      Notifications.error("Identifiant ou mot de passe incorrect");
      return null;
    });

    loader.hide();

    if (response) {
      if (response.hasOwnProperty("token")) {
        loginConfirmed(response.token);
      }
    }
  };

  const loginConfirmed = (token) => {
    Authentication.login(token);
    navigate("");
  };

  return Authentication.isLogged() ? (
    <Navigate to="/admin" replace />
  ) : (
    <>
      <div className="bg-white w-[400px] mx-auto mt-10 border-slate-700 border-2 rounded-lg py-6 px-10">
        <div className="text-center text-2xl font-bold text-slate-700 mb-8">
          Admin
        </div>
        <ValidationForm
          ref={form}
          onSubmit={submit}
          validationSchema={validationSchema}
          initialValues={{
            email: "",
            password: "",
          }}
        >
          <div>
            <div className="mb-6">
              <Label dark>Adresse email</Label>
              <Input type="email" name="email" placeholder="Adresse email" />
            </div>
            <div className="mb-6">
              <Label dark>Mot de passe</Label>
              <Input
                type="password"
                name="password"
                placeholder="Mot de passe"
              />
            </div>
          </div>
          <SubmitButton block>Se connecter</SubmitButton>
        </ValidationForm>
      </div>
    </>
  );
}
